export enum PaymentType
{
    CreditCard = 1,
    ECheck = 2
}